var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 20C0.447715 20 0 19.5523 0 19V18.0243C0 17.472 0.447715 17.0243 1 17.0243H15.6812C16.2335 17.0243 16.6812 17.472 16.6812 18.0243V19C16.6812 19.5523 16.2335 20 15.6812 20H1ZM1 14.0485C0.447715 14.0485 0 13.6008 0 13.0485V12.0728C0 11.5205 0.447715 11.0728 1 11.0728H15.6812C16.2335 11.0728 16.6812 11.5205 16.6812 12.0728V13.0485C16.6812 13.6008 16.2335 14.0485 15.6812 14.0485H1ZM0 7.09713C0 7.64942 0.447715 8.09713 1 8.09713H10.1208C10.6731 8.09713 11.1208 7.64942 11.1208 7.09713V6.1214C11.1208 5.56912 10.6731 5.1214 10.1208 5.1214H1C0.447715 5.1214 0 5.56911 0 6.1214V7.09713ZM13.9 6.26652C13.9 7.05747 14.7748 7.53535 15.4404 7.10795L19.5402 4.47499C20.1531 4.08143 20.1531 3.1857 19.5402 2.79214L15.4404 0.159184C14.7748 -0.268223 13.9 0.209658 13.9 1.00061V6.26652Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/queue.64d0edfb.svg";
export { ForwardRef as ReactComponent };